import { render, staticRenderFns } from "./MathStats.vue?vue&type=template&id=19a498bf&scoped=true"
import script from "./MathStats.vue?vue&type=script&lang=js"
export * from "./MathStats.vue?vue&type=script&lang=js"
import style0 from "./MathStats.vue?vue&type=style&index=0&id=19a498bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a498bf",
  null
  
)

export default component.exports